import { AccessTime, Cancel, CheckCircle } from "@mui/icons-material";
import { Table, TableBody, Box, TableCell, TableContainer, TableHead, TableRow, Typography, Checkbox } from "@mui/material";
import { memo, useState } from "react";
import MerchantDetailsDialog from "./MerchantDetailsDialog";
import { getTrancDetails } from "../../../../API/backendAPI";
import { Loader } from "../../../../HelperFunctions/HelperFunctions";
import { enqueueSnackbar } from "notistack";
import { useLoaderData } from "react-router-dom";
import dayjs from "dayjs";

const MerchantsTable = ({ columns, rows, selectedProfitCenter, selectedMerchantProvider, selectedDate }) => {
    const { Previlage, merchatScreenPrevilage } = useLoaderData();

    const FRONTEND_API_URL = process.env.REACT_APP_FRONTEND_API_URL


    const [detailsDialogData, setDetailsDialogData] = useState(null);
    const [loading, setLoading] = useState(false);
    const { clientNameURL, clientName, authId, corpId, menuId } = useLoaderData();
    const usAmountFormatter = new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    const formatCurrencyDisplay = (amount) => {
        const normalized = typeof amount === "string" ? amount.replace(/[$,\s]/g, "") : amount;
        const numericAmount = Number(normalized);
        return Number.isFinite(numericAmount) ? `$ ${usAmountFormatter.format(numericAmount)}` : amount;
    };

    const formatOutstandingAmount = (amount) => {
        const normalized = typeof amount === "string" ? amount.replace(/[$,\s]/g, "") : amount;
        const numericAmount = Number(normalized);
        return `$ ${usAmountFormatter.format(Number.isFinite(numericAmount) ? numericAmount : 0)}`;
    };


    const statusColors = {
        success: "#96eba6",
        warning: "#ffc107",
        error: "#ffaaa4",
        neutral: "#6c757d"
    };

    const ValueCell = memo(({ valueObj, onCheckboxClick }) => {

        if (!valueObj) return <span>-</span>;
        if (typeof valueObj === "string" || typeof valueObj === "number")
            return (
                <Box sx={{ width: "100%", display: "flex", justifyContent: "flex-end" }}>
                    <span>{formatCurrencyDisplay(valueObj)}</span>
                </Box>
            );

        const { value, status, transaction_ids } = valueObj;
        const color = statusColors[status] || "#6c757d";
        const icons = {
            success: <CheckCircle sx={{ fontSize: 16 }} />,
            error: <Cancel sx={{ fontSize: 16 }} />,
            warning: <AccessTime sx={{ fontSize: 16 }} />,
        };

        return (
            <Box display="flex" alignItems="center" justifyContent="flex-end" width="100%" gap={0.5}>
                {value !== "-" && <Checkbox
                    defaultChecked
                    size="small"
                    // onClick={() => setDetailsDialog(true)}
                    onClick={() => getStatusData(transaction_ids, status)}
                    icon={icons[status]}
                    checkedIcon={icons[status]}
                    // sx={{ p: 0.2, color, "&.Mui-checked": { color } }}
                    sx={{
                        p: 0.2,
                        color,
                        cursor: status === "error" ? "default" : "pointer",
                        "&.Mui-checked": { color },
                        "&:hover": {
                            cursor: status === "error" ? "default" : "pointer"
                        }
                    }}
                />}
                <span title={value}>{formatCurrencyDisplay(value)}</span>
            </Box>
        );
    });

    const getStatusData = async (transaction_ids, status) => {
        if (status === "error") {
            return;
        }

        try {
            setLoading(true);
            const payload = { transaction_ids }
            const transactions = await getTrancDetails(payload);
            setDetailsDialogData(transactions);

        } catch (error) {
            enqueueSnackbar("Error while getting status data", { variant: "error" })

        } finally {
            setLoading(false);
        }
    };
    const handleOutstandingBalanceClick = (row, rowIndex) => {

        if (!Previlage?.[0].Update) {
            enqueueSnackbar("You do not have sufficient privileges to perform this action", { variant: "warning" });
            return;
        };
        if (!merchatScreenPrevilage?.[0].Create) {
            enqueueSnackbar("You do not have sufficient privileges to perform this action", { variant: "warning" });
            return;
        }

        const merchantID =
            typeof selectedMerchantProvider === "string" && selectedMerchantProvider.trim()
                ? selectedMerchantProvider.trim()
                : "0";


        const pcID =
            selectedProfitCenter?.ID && selectedProfitCenter.ID !== "select"
                ? selectedProfitCenter.ID
                : "0";

        const fromDate = selectedDate
            ? dayjs(selectedDate).startOf("month").format("MM-DD-YYYY")
            : "";

        const toDate = selectedDate
            ? dayjs(selectedDate).endOf("month").format("MM-DD-YYYY")
            : "";

        const newUrl = `${FRONTEND_API_URL}/reconciliation/${clientName}/${authId}/${menuId}/${corpId}/${encodeURIComponent(
            merchantID
        )}/${encodeURIComponent(pcID)}/${fromDate}&${toDate}/outstanding/ds-cards`;

        const message = {
            type: "ds-cards",
            url: newUrl,
        };
        window.parent.postMessage(message, `${clientNameURL}NimblePropertyMetroIndex.aspx?q=639092311520691233`);
    };


    const RenderBar = memo(({ total, outstanding }) => {
        const totalNum = parseFloat(total) || 0;
        const outstandingVal = parseFloat(outstanding?.value) || 0;

        const paid = totalNum - outstandingVal;
        const percent = totalNum > 0 ? Math.min((paid / totalNum) * 100, 100) : 0;

        let barColor = "#fce1be";
        if (outstanding?.status === "success") {
            barColor = "#e0fbb5";
        } else if (outstanding?.status === "warning") {
            barColor = "#f4b3bb";
        }

        return (
            <Box
                sx={{
                    position: "relative",
                    width: "100%",
                    height: "100%",
                    bgcolor: "#f0f0f0",
                    borderTopRightRadius: 8,
                    borderBottomRightRadius: 8
                }}
            >
                <Box
                    sx={{
                        position: "absolute",
                        left: 0,
                        top: 0,
                        bottom: 0,
                        // width: `${percent}%`,
                        width: "100%",
                        bgcolor: barColor,
                        transition: "width 0.3s ease",
                        borderTopRightRadius: 8,
                        borderBottomRightRadius: 8
                    }}
                />
                <Typography
                    sx={{
                        position: "relative",
                        zIndex: 1,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-end",
                        height: "100%",
                        fontSize: 12,
                        fontWeight: 500,
                        color: "#626262",
                        mr: 0.5

                    }}>
                    {formatOutstandingAmount(outstanding?.value)}
                </Typography>
            </Box>
        );
    });


    const safeRows = Array.isArray(rows) ? rows : [];

    return (
        <>
            <TableContainer sx={{ overflow: "auto", height: "100%", border: "1px solid #f2f2f2" }}>
                <Table stickyHeader sx={{ width: "100%" }}>
                    <TableHead>
                        <TableRow sx={{ backgroundColor: "#d7d7d7" }}>
                            {columns.map((col, idx) => (
                                <TableCell
                                    key={idx}
                                    style={{
                                        backgroundColor: "#d7d7d7",
                                        borderRight: "1px solid white",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        fontSize: 13,
                                        maxWidth: col.width,
                                        textAlign: "left",
                                    }}
                                >
                                    <span title={col.columnName}>{col.columnName}</span>
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {safeRows.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={columns.length + 1} align="center" sx={{ fontSize: 14, color: "#999" }}>
                                    No data available
                                </TableCell>
                            </TableRow>
                        ) : (
                            safeRows.map((row, rowIndex) => (
                                <TableRow key={rowIndex} hover>
                                    {columns.map((col, idx) => (
                                        col.columnName === "Outstanding Balance" ? (
                                            <TableCell
                                                key={idx}
                                                onClick={() => handleOutstandingBalanceClick(row, rowIndex)}
                                                sx={{
                                                    p: 0,
                                                    m: 0,
                                                    borderRight: "1px solid #f2f2f2",
                                                    height: "40px",
                                                    cursor: "pointer",
                                                }}
                                            >
                                                <RenderBar
                                                    total={row.total}
                                                    outstanding={row["outstanding_balance"]}
                                                />
                                            </TableCell>
                                        ) : (
                                            <TableCell
                                                key={idx}
                                                sx={{
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    fontSize: 12,
                                                    fontWeight: 500,
                                                    color: "#626262",
                                                    borderRight: "1px solid #f2f2f2",
                                                    maxWidth: col.width,
                                                    p: col.columnName === "Outstanding Balance" ? 0 : undefined,
                                                    textAlign: col.columnName === "Date" ? "left" : "right",
                                                }}
                                            >
                                                {col.columnName === "Date" ? (
                                                    <span>{row[col.dataKey]}</span>
                                                ) : (
                                                    <ValueCell valueObj={row[col.dataKey]} />
                                                )}
                                            </TableCell>
                                        )
                                    ))}
                                </TableRow>


                            ))
                        )}
                    </TableBody>
                </Table>
            </TableContainer>

            {Boolean(detailsDialogData) &&
                <MerchantDetailsDialog
                    open={Boolean(detailsDialogData)}
                    onClose={() => setDetailsDialogData(null)}
                    data={detailsDialogData}
                />

            }

            {loading && <Loader loading={loading} />}

        </>
    );
};

export default MerchantsTable;
